/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { formatMessage } from "devextreme/localization";
import LoadPanel from "devextreme-react/load-panel";
import Form, { Label, StringLengthRule } from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import { postApproval } from "../../../services/approval";
import notify from "devextreme/ui/notify";
import {
  IsPermisionPathRequired,
  getTimekeepingApproval,
} from "../../../redux/actions";
import {
  responseMiddleware,
  responseTimekeeping,
} from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";
import TimekeepingOnlineApprovalTable from "./TimekeepingOnlineApprovalTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import { useAuth } from "../../../contexts/auth";
import PopupConfig from "../../../common/popup";
import { getStatusApproval, getCurrentPath } from "../../../common";

const y = new Date().getFullYear(),
  m = new Date().getMonth();

export default function TimekeepingOnlineApprovalList() {
  const formData = useRef({});
  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const { isXSmall, isSmall } = useScreenSize();
  const history = useHistory();
  const { middlewarePath: middleware, loading: middlewareLoading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const { timekeepingOnlineApproval } = useSelector(responseTimekeeping);

  const { user } = useAuth();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  const [filter, setFilter] = useState({
    Status: null,
    FromDate: new Date(y, m, 1).toLocaleDateString(),
    ToDate: new Date(y, m + 1, 0).toLocaleDateString(),
    EmployeeOid: user?.EmployeeOid,
  });

  useEffect(() => {
    dispatch(IsPermisionPathRequired(currentPath));
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  useEffect(() => {
    const getData = async () => {
      const state = getStatusApproval(window.location.href);
      setFilter({ ...filter, Status: state });
    };
    getData();
  }, []);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: filter.Status !== null ? `${filter.Status}` : null,
    };
    dispatch(getTimekeepingApproval(newPayload));
  };

  useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  const handleRefreshDataGrid = () => {
    dataGrid.current.instance.refresh();
  };

  const handleSendApprove = async (data) => {
    let payload = {
      EmployeeOid: filter.EmployeeOid,
    };
    if (data.Oid || data.items) {
      payload = {
        ...payload,
        ApprovalStatus: 1,
        Transactions: data.items ? data.items : [data],
      };
    } else {
      payload = {
        ...payload,
        ...formData.current,
        Transactions: popupConfig.data.items
          ? popupConfig.data.items
          : [popupConfig.data],
      };
    }
    try {
      await postApproval(payload, "ApproveTimekeeping");

      handleClosePopup();
      handleRefreshDataGrid();
      handleChangeSelectBox();
      notify("Successfully updated", "success", 2000);
    } catch (error) {
      handleChangeSelectBox();
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const renderViewPopup = () => {
    formData.current.ApprovalStatus = popupConfig.data.type;
    formData.current.Comment = "";
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={
          popupConfig.data.type === 1
            ? formatMessage("PopupTitleApprove")
            : formatMessage("PopupTitleReject")
        }
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form formData={formData.current}>
          <Item dataField="Comment" editorType="dxTextArea">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Comment")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleSendApprove}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={middlewareLoading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("TimeKeepingOnlineApproval")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/timekeeping-online/list" className={"breadcrumb-item"}>
            {formatMessage("TimeKeeping")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("TimeKeepingOnlineApproval")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}
          <TimekeepingOnlineApprovalTable
            dataGrid={dataGrid}
            middleware={middleware}
            handleOpenPopup={handleOpenPopup}
            approvalList={timekeepingOnlineApproval}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            handleSendApprove={handleSendApprove}
          />
        </div>
      </div>
    </div>
  );
}
